"use client";

import cn from "@utils/cn";
import React from "react";

import useMediaQuery from "./useMediaQuery";

function useResponsiveLabel(mobileLabel: string | undefined, desktopLabel: string): JSX.Element {
  const isDesktop = useMediaQuery("(min-width: 1280px)");
  const isMobile = useMediaQuery("(max-width: 1279px)");

  if (!isDesktop && mobileLabel) {
    return <span className="lg:hidden">{mobileLabel}</span>;
  }

  return <span className={cn(isMobile ? "hidden" : "")}>{desktopLabel}</span>;
}

export default useResponsiveLabel;
